export default __webpack_public_path__ + "static/1434-e5a0068409aad52ad25e734dfcb1f65b.gif";